import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosRequestHeaders, AxiosResponse } from "axios";
import { api } from "../../common/api";
import toast from "react-hot-toast";
import { baseErrors } from "../../assets/errors/baseErrors";
import { t } from "i18next";

type HttpMethod = "post" | "get" | "put" | "patch" | "delete";

type ApiMutationOptions<Variables, Response, Error> = {
  url: string;
  method: HttpMethod;
  options?: UseMutationOptions<Response, Error, Variables>;
  params?: Variables;
  headers?: AxiosRequestHeaders;
  mutationKey?: string;
};

const useApiMutation = <Variables, Response, Error>({
  url,
  method,
  options,
  params,
  headers,
  mutationKey,
}: ApiMutationOptions<Variables, AxiosResponse<Response>, Error>) =>
  useMutation<AxiosResponse<Response>, Error, Variables>({
    mutationFn: async (data: Variables) => {
      try {
        const response: AxiosResponse<Response> = await api({
          method,
          url,
          data,
          params,
          headers,
        });
        // toast.success(t(`TOAST_MESSAGES.${baseErrors[(response?.data as any)?.code || 0]}`));
        return response;
      } catch (error: any) {
        toast.error(t(`TOAST_MESSAGES.${baseErrors[error?.response?.data?.code || 1]}`));
        throw error;
      }
    },
    mutationKey: [mutationKey, url, method],
    ...options,
  });

export default useApiMutation;

